document.addEventListener('discount_kit:cart_changed', () => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    }));
    const drawer = document.getElementById('cart-drawer');
    drawer.show();
});
